import { nanoid } from 'nanoid';

import { DisplayPurposeProps } from '@sola/schema/dotcom/shared/display.ts';
import { ErrorBase } from '@sola/schema/dotcom/shared/errors.ts';

export class UserError implements ErrorBase {
  id?: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: Record<string, any> | Record<string, any>[];

  headers?: Record<string, string>;

  severity?: DisplayPurposeProps['variants'];

  statusCode?: number;

  type: string;

  userShouldFix?: boolean;

  constructor(
    args: Omit<UserError, 'id' | 'response' | 'responseOptions'> & {
      id?: string;
    },
  ) {
    this.id = args.id ?? nanoid();
    this.type = args.type;
    if (args.statusCode) {
      this.statusCode = args.statusCode;
    }
    if (args.severity) {
      this.severity = args.severity;
    }
    if (args.data) {
      this.data = args.data;
    }
    if (args.userShouldFix) {
      this.userShouldFix = args.userShouldFix;
    }
  }
}
